import { ThesisSubmissionIterationStatus } from '@rdm/db'

type RequiredFields = {
  statusHistory: Pick<ThesisSubmissionIterationStatus, 'id' | 'status' | 'outcome'>[]
}

/**
 * Returns the final statusHistory of a submission
 */
export const getCurrentIterationStatus = <T extends RequiredFields>(
  iteration: T,
): T['statusHistory'][0] | undefined => {
  if (!iteration || iteration.statusHistory.length === 0) return undefined

  return iteration.statusHistory.reduce((prev, current) => {
    return prev.id > current.id ? prev : current
  })
}
